<div class="content-container">
    @if (activityInstances.length > 0) {
        @for (activityInstance of activityInstances; track $index) {
            <adapt-activity-instance [activityElement]="activityInstance"
                                     imageSize="sm"
                                     [hideSubtext]="true"
                                     [showDate]="true"
                                     [useCompact]="true"
                                     [showAsUnread]="activityInstance.dateTime > lastReadTimestamp"></adapt-activity-instance>
        }
    } @else {
        <div class="d-flex justify-content-center fst-italic py-2">No recent activity</div>
    }
</div>

<div class="launch-button">
    <button adaptButton="iconlessLink"
            (click)="viewAllActivities()">View all activities</button>
</div>
